import React from 'react';
import { Card } from 'react-bootstrap';

const CompactStatsCard = ({ 
  icon, 
  title, 
  total, 
  stats, 
  primaryColor = '#6366F1'
}) => {
  return (
    <Card className="shadow-sm h-100">
      <Card.Body className="p-3">
        <div className="d-flex align-items-center mb-2">
          <span className="me-2 fs-5">{icon}</span>
          <h6 className="mb-0 text-muted">{title}</h6>
        </div>
        
        <div className="d-flex align-items-center justify-content-between">
          <div className="text-center">
            <div className="h3 mb-0" style={{color: primaryColor}}>{total}</div>
            <small className="text-muted">Total</small>
          </div>
          
          <div className="d-flex gap-3">
            {stats.map((stat, index) => (
              <div key={index} className="text-center">
                <div className={`fw-bold ${stat.colorClass || 'text-muted'}`}>
                  {stat.value}
                </div>
                <small className="text-muted" style={{fontSize: '0.75rem'}}>
                  {stat.label}
                </small>
              </div>
            ))}
          </div>
        </div>
      </Card.Body>
    </Card>
  );
};

export default CompactStatsCard;